<template>
    <div>
        <div style="color: red; font-size: 13px; text-align: center">**ยอดเงินรับ ใส่ได้เฉพาะคุณมดและเฮียเท่านั้น</div>
        <div class="row form-group">
            <div :class="labelCol">
                ยอดเงินรับ
            </div>
            <div :class="inputCol">
                <input class="form-control" type="number" v-model="form.income" :disabled="!canViewSuperAdmin"/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">
                ยอดยกมาจากครั้งก่อน
            </div>
            <div :class="inputCol">
                <input class="form-control" type="number" v-model="form.income_before"/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">
                หักจ่ายเบ็ดเตล็ด
            </div>
            <div :class="inputCol">
                <input class="form-control" type="number" v-model="form.other_withdraw"/>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">
                วันที่ - เวลาเริ่มต้น
            </div>
            <div :class="timeCol">
                <date-picker
                    v-model="form.start_date"
                    type="date"
                    :format="changeFormat"
                    :lang="lang"
                    confirm
                    class="w-100"
                    placeholder="วันที่เริ่มต้น">
                </date-picker>
            </div>
            <div :class="timeCol">
                <date-picker
                    v-model="form.start_time"
                    type="time"
                    format="HH:ss"
                    lang="en"
                    confirm
                    class="w-100"
                    placeholder="เวลาเริ่มต้น">
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">
                วันที่ - เวลาสิ้นสุด
            </div>
            <div :class="timeCol">
                <date-picker
                    v-model="form.end_date"
                    type="date"
                    :format="changeFormat"
                    :lang="lang"
                    confirm
                    class="w-100"
                    placeholder="วันที่สิ้นสุด">
                </date-picker>
            </div>
            <div :class="timeCol">
                <date-picker
                    v-model="form.end_time"
                    type="time"
                    format="HH:ss"
                    lang="en"
                    confirm
                    class="w-100"
                    placeholder="เวลาสิ้นสุด">
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div :class="labelCol">รายละเอียดเพิ่มเติม</div>
            <div :class="inputCol">
                <textarea class="form-control" v-model="form.reason"></textarea>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึกและพิมพ์
            </button>
            &nbsp&nbsp
            <button type="button"
                    @click="cancelData"
                    style="width: 150px"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment';
import {canViewSuperAdmin} from "../../../util/Permissions";

export default {
    name: "DriverTransportReportModal",
    props: {form: null},
    components: {
        DatePicker,
    },
    computed: {
        canViewSuperAdmin,
    },
    data() {
        return {
            timeCol: 'col-4',
            inputCol: 'col-8',
            labelCol: 'col-4 text-right',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        submitData() {
            this.$emit("submit", this.form)
        },
        cancelData() {
            this.$emit("submit", false)
        }
    },
}
</script>

<style scoped>

</style>
